<script setup>
definePage({
  meta: {
    action: 'read',
    subject: 'subject',
  },
})

import { status } from '@/datas/subject'
import { getProjectId } from "@/utils/cdms"
import { isLockedProject } from '@/utils/project'
import { useESignatureStore } from "@/utils/stores/esignature"
import ConfirmReason from "@/views/build/common/confirmReason.vue"
import ConfirmDialogCustom from '@/components/dialogs/ConfirmDialogCustom.vue'
import { VDataTable } from 'vuetify/labs/VDataTable'

const { t } = useI18n()




const { data: project } = await useApi(createUrl(`/projects/${getProjectId()}`)) 

// 옵션 토글
const showSurveys     = !!project?.has_guardian_survey
const showAssignTest = project?.value.has_randomization === 1
const trialBlinding = project?.value?.trial_blinding ?? null // 'OPEN' | 'BLIND' | null

// BT(눈가림 시험자) 역할 확인
const userData = useCookie('userData')
const isBTRole = computed(() => userData.value?.role === 'BT')
const hideAssignment = computed(() => trialBlinding === 'BLIND')

// 동물 등록 차단 토글
const subjectAddDisabled = ref(!!project?.value?.subject_add_disabled)

const toggleSubjectAdd = async () => {
  await $api(`/projects/${getProjectId()}/toggle-subject-add`, { method: 'POST' })
  subjectAddDisabled.value = !subjectAddDisabled.value
}

 

const esignatureStore = useESignatureStore()
const page = ref(1)
const itemsPerPage = ref(10)

const headers =
showAssignTest?
  ref([
  // {
  //   title: 'ID',
  //   key: 'subject_id',
  // },
    {
      title: t('Site Name'),
      key: 'site_name',
    },
    {
      title: t('Subject Name'),
      key: 'name',
    },
    { title: t('Chart No'),  key: 'chart_no' },
    { title: t('Subject Number'),  key: 'subject_no' },
    { title: t('Status'),  key: 'status' },
    { title: t('Assignment'),  key: 'Assignment' },
    { title: 'DRUG No.',  key: 'DrugNo' },
    { title: t('Move'),  key: 'Move' },
    { title: t('Edit'),  key: 'actions', sortable: false, width: "120px" },
  ]):ref([
  // {
  //   title: 'ID',
  //   key: 'subject_id',
  // },
    {
      title: t('Site Name'),
      key: 'site_name',
    },
    {
      title: t('Subject Name'),
      key: 'name',
    },
    { title: t('Chart No'),  key: 'chart_no' },
    { title: t('Subject Number'),  key: 'subject_no' },
    { title: t('Status'),  key: 'status' }, 
    { title: t('Move'),  key: 'Move' },
    { title: t('Edit'),  key: 'actions', sortable: false, width: "120px" },
  ])


const statusText = val => {
  return status.find(({ value }) => value == val)?.text
}

const projectLocked = ref(await isLockedProject())

const {
  data: subjectsData,
  execute: fetchSubjects,
} = await useApi(createUrl('/subjects', {
  query: {
    projectId: getProjectId(),
  },
}))

const subjects = computed(() => subjectsData.value?.map(item => ({
  ...item,
  Assignment: item.assigned_group || '',
  DrugNo: item.assigned_drug_no || '',
  Move: item.status,
})))

const updateOptions = options => {
  page.value = options.page
}

// 완전 삭제 확인 다이얼로그
const isForceDeleteDialogVisible = ref(false)
const forceDeleteTarget = ref(null)

// 중도탈락(일반 삭제)용 사유 목록
const SUBJECT_WITHDRAW_REASON_OPTIONS = [
  { label: '선정미달 또는 제외조건', value: 0 },
  { label: '보호자 참여 철회', value: 1 },
  { label: '이상반응', value: 2 },
  { label: '병용금지 약물복용 및 처치', value: 3 },
  { label: '기타', value: 4 },
]

const deleteItem = item => {
  esignatureStore.$reset()
  esignatureStore.options = {
    title: "중도탈락하는 사유를 입력해 주세요.",
    subTitle: "중도탈락 사유",
    item,
    type: "Delete",
  }
  esignatureStore.isDialogVisible = true
}

const restoreItem = item => {
  esignatureStore.$reset()
  esignatureStore.options = {
    title: "복원하는 사유를 입력해 주세요.",
    subTitle: "복원 사유",
    item,
    type: "Restore",
  }
  esignatureStore.isDialogVisible = true
}


const deleteForceItem = item => {
  forceDeleteTarget.value = item
  isForceDeleteDialogVisible.value = true
}

const handleForceDeleteConfirm = async result => {
  if (!result || !forceDeleteTarget.value) {
    isForceDeleteDialogVisible.value = false
    forceDeleteTarget.value = null
    
    return
  }

  await $api(`/subjects/${forceDeleteTarget.value.id}`, {
    method: 'DELETE',
    body: { reason: '', force: true },
  })

  isForceDeleteDialogVisible.value = false
  forceDeleteTarget.value = null
  fetchSubjects()
}

const setConfirm = async ({ result, options }) => {
  if (result) {
    if (options.value.type == "Restore") {
      await $api(`/subjects/restore/${options.value.item.id}`, {
        method: 'DELETE',
        body: { reason: options.value.reason },
      })
    } else if (options.value.type == "ForceDelete") {
      await $api(`/subjects/${options.value.item.id}`, {
        method: 'DELETE',
        body: { reason: options.value.reason, force: true },
      })
    } else {
      await $api(`/subjects/${options.value.item.id}`, {
        method: 'DELETE',
        body: { reason: options.value.reason },
      })
    }
    fetchSubjects()
  }
}

const subjectHistory = ref([])
const isListSubjectHistoryVisible = ref(false)

const showHistory = async item => {
  const {
    data,
  } = await useApi(createUrl(`/subjects/${item.id}/history`, {
    query: {
    },
  }))

  subjectHistory.value = data.value
  isListSubjectHistoryVisible.value = true
}

function checkCondition(item) {
  console.log('조건 확인 클릭됨:', item)

  // 실제 조건 확인 로직 추가
}

function startVisit(item) {
  console.log('방문 시작 클릭됨:', item)

  // 실제 방문 시작 로직 추가
}
const isSnackbarVisible = ref(false)

onMounted(() => {
  if (showAssignTest) {
    isSnackbarVisible.value = true
  }
})

const search = ref('')

const filterItems = [
  { value: "site_name", title: "기관명" },
  { value: "name", title: "동물(검체)이름" },
  { value: "subject_no", title: "식별번호" },
]

const filterItem = ref('name')

const filterText = (value, query, item) => {
  return value != null &&  query != null &&
        typeof value === 'string' &&
        item.columns[filterItem.value].toLowerCase().indexOf(query.toLowerCase()) !== -1
}

watch(() => [search.value, filterItem.value], () => {
  page.value = 1
})
</script>

<template>
  <h3 class="text-lg font-semibold mb-8">
    동물(검체) 관리
  </h3>
  <VSnackbar
    v-model="isSnackbarVisible"
    :timeout="2000"
    location="top"
  >
    처음 동물 등록시 시험군 배정부터 진행 후 eCRF 입력을 눌러주세요.
  </VSnackbar>
  <ConfirmReason
    :reason-options="esignatureStore.options?.type === 'Restore' ? undefined : SUBJECT_WITHDRAW_REASON_OPTIONS"
    :require-input-for-all="esignatureStore.options?.type !== 'Restore'"
    @confirm="setConfirm"
  />
  <ConfirmDialogCustom
    v-model="isForceDeleteDialogVisible"
    confirm-title="완전 삭제 확인"
    confirm-msg="선택한 검체를 완전 삭제하시겠습니까?"
    confirmation-question="이 검체를 완전 삭제하면 복구할 수 없습니다.<br> 진행하시겠습니까?"
    confirm-color="error"
    cancel-msg="취소"
    @confirm="handleForceDeleteConfirm"
  />
  <ListSubjectHistoryDialog
    v-model:is-dialog-visible="isListSubjectHistoryVisible"
    :history-data="subjectHistory"
  />
  <VCard>
    <VCardText>
      <div class="d-flex justify-space-between flex-wrap gap-y-4">
        <div />
        <div class="d-flex flex-row align-center flex-wrap">
          <AppSelect
            v-model="filterItem"
            :items="filterItems"
            style="inline-size:150px;"
          />
          <VTextField
            v-model="search"
            style="inline-size:200px;"
            class="pe-4"
            density="compact"
            label="Search"
            flat
            hide-details
            single-line
          />
          <VSwitch
            v-if="$can('pm', 'project') || isBTRole"
            :model-value="!subjectAddDisabled"
            hide-details
            density="compact"
            class="me-4"
            label="등록 허용"
            @change="toggleSubjectAdd"
          />
          <VBtn
            v-if="$can('write', 'subject')"
            append-icon="tabler-plus"
            color="#3E71FE"
            :disabled="projectLocked || subjectAddDisabled"
            @click="$router.push('/subjectsV2/create')"
          >
            {{ $t('Add Subject') }}
          </VBtn>
        </div>
      </div>
    </VCardText>
    <VCardText>
      <VDataTable
        v-model:search="search"
        :custom-filter="filterText"
        :headers="headers"
        :items="subjects"
        density="compact"
        :items-per-page="itemsPerPage"
        :page="page"
        must-sort
        class="custom-table"
        @update:options="updateOptions"
      >
        <template #item.id="{ item }">
          <div :class="{'deleted' : item.deleted !=0}">
            {{ item.id }}
          </div>
        </template>

        <template #item.name="{ item }">
          <div
            v-if="item.deleted"
            :class="{'deleted' : item.deleted !=0}"
          >
            {{ item.name }}
          </div>
          <div v-if="!item.deleted">
            {{ item.name }}
          </div>
        </template>

        <template #item.chart_no="{ item }">
          <div :class="{'deleted' : item.deleted !=0}">
            {{ item.chart_no }}
          </div>
        </template>

        <template #item.site_name="{ item }">
          <div :class="{'deleted' : item.deleted !=0}">
            {{ item.site_name }}
          </div>
        </template>

        <template #item.subject_no="{ item }">
          <div
            v-if="item.deleted"
            :class="{'deleted' : item.deleted !=0}"
          >
            {{ item.subject_no }}
          </div>
          <div v-if="!item.deleted">
            {{ item.subject_no }}
          </div>
        </template>

        <template #item.status="{ item }">
          <div :class="{'deleted' : item.deleted !=0}">
            <div v-if="item.assigned_group && item.status === 30">
              시험진행
            </div>
            <div v-else>
              {{ statusText(item.status) }}
            </div>
          </div>
        </template>
        <template #item.Assignment="{ item }">
          <div
            v-if="item.deleted"
            :class="{'deleted' : item.deleted != 0}"
          >
            <!-- Blind: 군 정보 숨김 (조건 불충족은 표시) -->
            <template v-if="item.assigned_group === '조건 불충족'">조건 불충족</template>
            <template v-else>{{ hideAssignment ? '-' : item.assigned_group }}</template>
          </div>
          <RouterLink
            v-else
            :to="{ name: 'assignment-answer-project-subject-schedule', params: { project: String(getProjectId()), subject: String(item.id), schedule:String(0) } }"
          >
            <div class="d-flex justify-start flex-wrap gap-3">
              <div v-if="item.assigned_group">
                <!-- 조건 불충족은 항상 표시 / Blind: 군 정보 숨김 / Open: 군 정보 표시 -->
                <span v-if="item.assigned_group === '조건 불충족'">조건 불충족</span>
                <span v-else-if="hideAssignment">-</span>
                <span v-else>{{ item.assigned_group }}</span>
              </div>
              <VBtn
                v-else
                color="#6173CC"
                @click="checkCondition(item)"
              >
                군배정
              </VBtn>
            </div>
          </RouterLink>
        </template>
        <template #item.DrugNo="{ item }">
          <span
            v-if="item.assigned_drug_no"
            class="drug-no-badge"
          >
            {{ item.assigned_drug_no }}
          </span>
          <span v-else>-</span>
        </template>
        <template #item.Move="{ item }">
          <!-- 중도탈락(삭제)된 검체: view 페이지에서 deleted 상태 기반으로 읽기전용 처리 -->
          <template v-if="item.deleted">
            <RouterLink :to="{ name: 'subjects-v2-view-id', params: { id: item.id } }">
              <div class="d-flex justify-start flex-wrap gap-3">
                <VBtn
                  style="text-transform: none !important;"
                  color="#9E9E9E"
                >
                  eCRF 확인
                </VBtn>
              </div>
            </RouterLink>
          </template>

          <!-- 미배정 상태 (showAssignTest일 때) -->
          <template v-else-if="[10, 20, 40].includes(item.status) && showAssignTest">
            <div class="d-flex justify-start flex-wrap gap-3">
              <VBtn
                style="text-transform: none !important;"
                color="#9E9E9E"
                disabled
              >
                eCRF 입력
              </VBtn>
            </div>
          </template>

          <!-- 라우팅 가능한 경우 -->
          <RouterLink
            v-else
            :to="{ name: 'subjects-v2-view-id', params: { id: item.id } }"
          >
            <div class="d-flex justify-start flex-wrap gap-3">
              <VBtn
                style="text-transform: none !important;"
                :disabled="[10, 20, 40].includes(item.status) && item.assigned_group"
                :color="item.status === 50 ? '#9E9E9E' : '#6173CC'"
                @click="startVisit(item)"
              >
                {{ item.status === 50 ? '기록 수정' : 'eCRF 입력' }} 
              </VBtn>
            </div>
          </RouterLink>
        </template>

        <template #item.species="{ item }">
          <div :class="{'deleted' : item.deleted !=0}">
            {{ item.species }}
          </div>
        </template>

        <template #item.breed="{ item }">
          <div :class="{'deleted' : item.deleted !=0}">
            {{ item.breed }}
          </div>
        </template>

        <template #item.sex="{ item }">
          <div :class="{'deleted' : item.deleted !=0}">
            <!-- {{ sex.filter(s => s.value == item.sex)[0]?.text }} -->
            {{ item.sex }}
          </div>
        </template>

        <template #item.birthday="{ item }">
          <div :class="{'deleted' : item.deleted !=0}">
            {{ item.birthday }}
          </div>
        </template>

        <template #item.actions="{ item }">
          <div class="d-flex gap-1">
            <IconBtn @click="showHistory(item)">
              <VIcon icon="tabler-file-spreadsheet" />
              <VTooltip
                activator="parent"
                location="top"
              >
                {{ $t('History') }}
              </VTooltip>
            </IconBtn>

            <IconBtn
              v-if="!item.deleted && $can('write', 'subject')"
              :disabled="projectLocked"
              @click="$router.push({ name: 'subjects-v2-edit-id', params: {id:item.id} })"
            >
              <VIcon icon="tabler-edit" />
              <VTooltip
                activator="parent"
                location="top"
              >
                수정
              </VTooltip>
            </IconBtn>

            <IconBtn
              v-if="item.deleted && $can('write', 'subject')"
              :disabled="projectLocked"
              @click="restoreItem(item)"
            >
              <VIcon
                icon="tabler-restore"
                color="error"
              />
              <VTooltip
                activator="parent"
                location="top"
              >
                {{ $t('Restore') }}
              </VTooltip>
            </IconBtn>

            <!-- 완전 삭제: delete 권한 필요 -->
            <IconBtn
              v-if="(item.deleted || item.status === 10) && $can('delete', 'subject')"
              :disabled="projectLocked"
              @click="deleteForceItem(item)"
            >
              <VIcon
                icon="tabler-trash"
                color="error"
              />
              <VTooltip
                activator="parent"
                location="top"
              >
                삭제
              </VTooltip>
            </IconBtn>
            <!-- 중도탈락(논리 삭제): delete 권한 필요 -->
            <IconBtn
              v-if="(!item.deleted && item.status !== 10) && $can('write', 'subject')"
              :disabled="projectLocked"
              @click="deleteItem(item)"
            >
              <VIcon
                icon="tabler-x"
                color="error"
              />
              <VTooltip
                activator="parent"
                location="top"
              >
                중도탈락
              </VTooltip>
            </IconBtn>
          </div>
        </template>
      </VDataTable>
    </VCardText>
  </VCard>
</template>

<style lang="scss" scoped>
.deleted {
  opacity: 0.5;
}

.justify-start{
  display: flex;
  justify-items: start;
}

.v-data-table .v-table__wrapper > table > thead > tr > th,
.v-data-table .v-table__wrapper > table > tbody > tr > th {
  font-size: 15px;
}



:deep(.custom-table .v-table__wrapper table) {
  th {
    background: #F3F5F8 !important;  /* 밝은 회색 배경 */
    border-block-end: 1px solid #eee;
    color: #909090 !important;       /* 연한 회색 텍스트 */
    font-size: 13px;
    font-weight: 500;
    padding-block: 10px;
    padding-inline: 12px;
  }

  td {
    border-block-end: 1px solid #E8EBEE;
    color: #444;
    font-size: 14px;
    padding-block: 8px;
    padding-inline: 12px;
  }

  tr:hover td {
    background-color: #f9f9fc; /* hover 시 은은한 하이라이트 */
  }
}

:deep(.custom-table .v-badge__badge) {
  border-radius: unset;
  font-size: 8px;
  margin-inline-start: 5px;
  min-inline-size: 10px;
}

:deep(.v-card-item) {
  padding: 12px;
}
:deep(.no-uppercase .v-btn__content){ text-transform: none !important; }
.text-none { text-transform: none !important; }

.drug-no-badge {
  display: inline-block;
  background: #EEF2FF;
  border: 1px solid #C7D2FE;
  border-radius: 6px;
  color: #4338CA;
  font-size: 13px;
  font-weight: 600;
  padding-block: 2px;
  padding-inline: 8px;
}

.drug-no-sub {
  color: #6366F1;
  font-size: 12px;
  font-weight: 500;
}
</style>
